module.exports = __webpack_public_path__ + "img/International Key.ce368348.png";